import { Component, OnInit } from '@angular/core';
import { InitScripts } from '../app.constants';
import { MetamanagerService } from '../metamanager.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  constructor(private metaManager: MetamanagerService) {
    new InitScripts().loadScripts();
  }

  ngOnInit(): void {
    this.metaManager.updateMetaTitle("Contact Us | sarvadhnya.com",
      "आदिकरण श्री दत्तात्रेय प्रभू, श्री गुरुवर्य आणि अखिल परमार्ग",
      "");
  }
}
